module.exports = __webpack_public_path__ + "img/dislike.7ab4bf97.svg";